import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { EmptyStateTitle } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface EmailTemplatesErrorStateProps {
  /** Wired by the parent to the query's `refetch`. */
  onRetry: () => void;
}

/**
 * Shown when the templates query fails with no previous data to fall back on. `role="alert"` so
 * the failure is announced rather than leaving a silently empty table.
 */
export function EmailTemplatesErrorState({ onRetry }: EmailTemplatesErrorStateProps) {
  const { t } = useTranslation('admin');

  return (
    <Empty role="alert" data-testid="email-templates-error-state" className="flex-1">
      <EmptyHeader>
        <EmptyStateTitle>
          {t('templatesConfig.errorState.couldntLoadEmailTemplates')}
        </EmptyStateTitle>
        <EmptyDescription>
          {t('templatesConfig.errorState.somethingWentWrongPleaseTry')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" size="default" onClick={onRetry}>
          {t('templatesConfig.errorState.retry')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
